<!--单job校验-->
<template>
  <el-dialog :visible.sync="innerVisible" :title="title" width="620px" :close-on-click-modal="false" @close="closeHandler">
    <check-result-display :current-state="currentState" :title="title" />
    <div v-if="dataSource.length > 0" class="single-wrap">
      <el-scrollbar>
        <check-item-renderer v-if="currentState != 'checking' && dataSource.length > 0" :data="dataSource" :data-type="dataType" />
      </el-scrollbar>
    </div>
    <template v-if="!!remark">
      <el-divider />
      <div>
        {{ remark }}
      </div>
    </template>
    <!--<div v-show="labelRemark.visible" class="app-main-inner-row" style="padding: 0px;">-->
    <div class="app-main-inner-row" style="padding: 0px;">
      <span v-show="labelRemark.visible" style="color:red; line-height: 24px;">{{ labelRemark.text }}</span>
      <span v-show="labelRemark2.visible">{{ labelRemark2.text }}</span>
    </div>

    <div v-show="areaRemark.visible">
      <el-input v-model="areaRemark.text" no="1" :disabled="!areaRemark.editable" type="textarea" :row="5" />
    </div>

    <div class="app-main-inner-row" style="padding: 0px;">
      <span v-show="labelRejectRemark.visible">{{ labelRejectRemark.text }}</span>
      <span v-show="labelRejectRemark2.visible" style="color: red;">{{ labelRejectRemark2.text }}</span>
    </div>
    <div v-show="areaRejectRemark.visible">
      <el-input v-model="areaRejectRemark.text" no="2" :disabled="!areaRejectRemark.editable" type="textarea" :row="5" />
    </div>
    <div class="split-empty-div" />
    <span slot="footer">
      <el-button v-show="btn.showAgreeButton" no="3" type="primary" @click="submitAgreeHandler">{{ $t('CargoMsg.Cargo_Agree') }}</el-button>
      <el-button v-show="btn.showRefuseButton" no="4" type="danger" @click="submitRefuseHandler">{{ $t('CargoMsg.Cargo_Refuse') }}</el-button>
      <el-button v-show="btn.showSubmitAuditButton" no="5" type="primary" @click="submitAuditHandler">{{ $t('Message.SubmitAudit') }}</el-button>
      <el-button v-show="btn.showConfirmButton && currentState!==states.failure && currentState!==states.checking" no="6" type="primary" @click="continueHandler">{{ btn.confirmText }}</el-button>
      <el-button v-show="btn.showCloseButton" no="7" type="danger" @click="closeHandler">{{ btn.closeText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { checkAnyContent } from '@/api/sysManage/baseConfig/checkRuleConfig'

const states = {
  checking: 'checking',
  success: 'success',
  warning: 'warning',
  failure: 'failure'
}

import ErrorTip from '@/utils/class/ErrorTip'
import CheckResultDisplay from './CheckResultDisplay'
import { User } from '@/class/model/sys/User'
import { Job } from '@/class/model/booking/Job'
import CheckingWindowHP from './CheckingWindowHP'
import CheckItemRenderer from './CheckItemRenderer'
import {
  checking,
  checkingWithNewData,
  auditSubmission,
  saveOrderAuditRemark,
  checkingBySpecialNode
} from '@/api/booking/job'
import { getUserByUserId } from '@/api/user'

import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JOB, USER } from '@/class/cargo/model/parameters/CheckRuleConstants'
import { CheckRuleUtil } from '@/class/cargo/model/utils/CheckRuleUtil'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'CheckingWindow',
  components: { CheckResultDisplay, CheckItemRenderer },
  props: {
    visible: { type: Boolean, required: true },
    // When enabled, auto-close the dialog as soon as validation passes (state=success).
    // Warnings/failures still require manual user confirmation/close.
    autoCloseOnSuccess: { type: Boolean, default: true },
    checkNode: { type: Number, required: true },
    lob: { type: String, required: true },
    job: { type: Object, required: true }, // , validator: (value) => { return value instanceof Job }
    checkContent: { type: Object, required: false }, // CARGO-31252 支持所有类型
    callBack: { type: Function, default: null },
    callBack2: { type: Function, default: null },
    closeCallback: { type: Function, default: null },
    newJob: { type: Object, default: null }
  },
  data() {
    return {
      states,
      innerVisible: false,
      checkingWindowHP: new CheckingWindowHP(this),
      currentState: states.checking,
      dataSource: [],
      loadings: [], // // todo-shengsheng  Desc:  加载列表 暂放，可能不需要
      remark: '',
      labelRemark: {
        text: '',
        visible: false
      },
      labelRemark2: {
        text: '',
        visible: false
      },
      areaRemark: {
        height: 100,
        text: '*',
        visible: false,
        editable: false
      },
      areaRejectRemark: {
        text: '',
        visible: false,
        editable: false
      },
      labelRejectRemark: {
        text: '',
        visible: false
      },
      labelRejectRemark2: {
        text: '*',
        visible: false
      },
      checkState: states.checking, // 验证状态
      showCheckResultDisplay: false,
      auditType: false, // 是否预提交审核
      title: '',
      returnValue: false, // 方法回调返回值
      btn: {
        confirmText: this.$t('CargoMsg.Cargo_ConfirmR'),
        closeText: this.$t('CargoMsg.Cargo_Close'),
        showRefuseButton: false,
        showAgreeButton: false,
        showSubmitAuditButton: false,
        showConfirmButton: false,
        showCloseButton: false
      },
      dataType: JOB.code

    }
  },
  errorCaptured(err) { // // todo-shengsheng  Desc: 异步异常测试
    if (err instanceof ErrorTip) {
      this.$message(err)
      return false
    }
    return true
  },
  computed: {
    currentUserId() {
      return this.$store.getters.userInfo.userId
    },
    currentUserName() {
      return this.$store.getters.userInfo.chineseName
    }
  },
  watch: {
    currentState: {
      handler(val) {
        if (val === this.states.success) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_ConfirmR')
        } else if (val === this.states.warning) {
          this.btn.confirmText = this.$t('CargoMsg.Cargo_GoOn')
        } else if (val === this.states.failure) {
          this.btn.closeText = this.$t('CargoMsg.Cargo_Close')
        } else {
          this.btn.closeText = this.$t('CargoMsg.Cargo_Cancel')
        }
      },
      immediate: true
    },
    visible: {
      async handler(val) {
        if (this.isDebugEnabled()) {
          // eslint-disable-next-line no-console
          console.log(`[CheckingWindow][debug] visible changed: visible=${val} checkNode=${this.checkNode} autoCloseOnSuccess=${this.autoCloseOnSuccess}`)
        }
        if (val) {
          let loading = null
          try {
            const setting = await CheckRuleUtil.getCheckRuleSetting()
            const checkNodes = this.toNumArray(setting.multiCheckNode)
            const checkModes = this.toNumArray(setting.multiCheckMode)
            if (this.isDebugEnabled()) {
              // eslint-disable-next-line no-console
              console.log(`[CheckingWindow][debug] checkRuleSetting: popupMode=${!!(setting && setting.popupMode)} multiCheckNode=${(setting && setting.multiCheckNode) || ''} multiCheckMode=${(setting && setting.multiCheckMode) || ''} checkNode=${this.checkNode} inMultiCheckNode=${checkNodes.includes(this.checkNode)}`)
            }
            if (setting.popupMode && checkNodes.includes(this.checkNode)) {
              loading = getLoading()
              await this.addedToStageHandler()
              // popupMode: original behavior auto-closes on success; extend to warning when autoCloseOnSuccess is enabled.
              const passed = (this.checkState === this.states.success) || (this.autoCloseOnSuccess && this.checkState === this.states.warning)
              if (passed && this.matchCheckMode(checkModes)) {
                const msgType = this.checkState === this.states.success ? 'success' : 'warning'
                this.$message[msgType](this.$t('Message.N0VerificationPassed', [this.title]))
                if (this.isDebugEnabled()) {
                  // eslint-disable-next-line no-console
                  console.log(`[CheckingWindow][debug] popupMode auto-close -> continueHandler(): checkState=${this.checkState}`)
                }
                this.continueHandler()
              } else {
                this.innerVisible = true
              }
            } else {
              this.addedToStageHandler()
              this.innerVisible = true
            }
          } catch (e) {
            if (this.isDebugEnabled()) {
              // eslint-disable-next-line no-console
              console.log(`[CheckingWindow][debug] visible handler error: ${e && e.message ? e.message : String(e)}`)
            }
            this.innerVisible = true
          } finally {
            loading && loading.close()
          }
        } else {
          this.innerVisible = false
        }
      },
      immediate: true
    }
  },
  created() {
  },
  beforeMount() {

  },
  methods: {
    isDebugEnabled() {
      // Temporary: always-on debug logs to locate why auto-close doesn't trigger.
      // TODO: remove after issue is confirmed.
      return true
    },
    toNumArray(txt) {
      if (txt) {
        return Array.from(txt.split(','), p => Number(p))
      }
      return []
    },
    // 匹配验证模式
    matchCheckMode(checkModes) {
      if (this.dataSource && this.dataSource.length > 0) {
        for (const item of this.dataSource) {
          if (item.hasOwnProperty('checkMode') && !checkModes.includes(item.checkMode)) {
            return false
          }
        }
      }
      return true
    },
    async addedToStageHandler() {
      const node = CommonState.getStateByCode(CheckRuleConstants.CHECK_NODES, this.checkNode)
      this.title = this.$store.getters.language === 'zh' ? node.chineseName : node.englishName
      this.checkState = 'checking'
      this.currentState = 'checking'

      this.remark = null
      if (CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode]) { this.remark = CheckRuleConstants.NODE_REMARK_MAPPING[this.checkNode] }
      this.buttonShow2(false)

      this.areaRemark.text = ''
      this.areaRejectRemark.text = ''
      // const results = [{ match: true, continueCheck: false, checkNode: 1, ruleName: 'ruleName', checkMode: 'checkMode', checkCategory: 'checkCategory',
      //   expressions: [{ checkItem: 'checkItem', checkValue: 'checkValue', operator: 'operator', match: true }, { checkItem: 'checkItem', checkValue: 'checkValue', operator: 'operator', match: true }]
      // }]
      // todo 待优化
      if (this.checkNode === CheckRuleConstants.NODE_SAVE_USER.code) {
        this.dataType = USER.code
        if (this.checkContent) {
          await checkAnyContent(this.checkContent, this.checkNode).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        } else {
          this.checkingResultHandler([])
        }
      } else if (this.checkNode === CheckRuleConstants.NODE_AUDIT_COMMIT.code) {
        // 主管审核 验证提交节点
        // Job.checking(2, job.key, checkingResultHandler, checkFaultHandler);
        if (this.newJob) {
          await checkingWithNewData(CheckRuleConstants.NODE_COMMIT.code, this.job.uuid, this.job.lob, this.newJob).then(res => {
            this.checkingResultHandler(res.data || [])
          })
        } else {
          await checking(CheckRuleConstants.NODE_COMMIT.code, this.job.uuid, this.job.lob).then(res => {
            this.checkingResultHandler(res.data || [])
          })
        }
      } else if (this.checkNode === CheckRuleConstants.NODE_BILL_AR_SURE.code) {
        // CARGO-47750 应收账单确认，增加必录项校验“纳税人识别号”、“客户邮箱”
        const data = {
          'checkNode': CheckRuleConstants.NODE_BILL_AR_SURE.code,
          'jobKey': this.job.uuid,
          'lob': this.job.lob,
          'keys': this.job.internalBillUuidList
        }
        await checkingBySpecialNode(data).then(res => {
          this.checkingResultHandler(res.data || [])
        })
      } else {
        // 显示异常提示
        this.showCheckResultDisplay = true
        // Job.checking(this.checkNode, job.key, checkingResultHandler, checkFaultHandler);
        if (this.newJob) {
          await checkingWithNewData(this.checkNode, this.job.uuid, this.job.lob, this.newJob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        } else {
          await checking(this.checkNode, this.job.uuid, this.job.lob).then(res => {
            this.checkingResultHandler(res.data || [])
          }).catch(() => {
            this.faultHandler()
          })
        }
      }
    },
    /**
     * 显示提交人标签
     */
    remarkShow(isEdit) {
      this.labelRemark.visible = isEdit
      this.labelRemark2.visible = !isEdit
      if (isEdit) {
        this.labelRemark.text = this.$t('Message.PleaseInTheSubmissionNotes')
      } else {
        this.labelRemark2.text = this.$t('Message.SubmittersRemarks')
      }
    },
    /**
     * 按钮显示控制
     * @param show
     */
    buttonShow2(show) {
      this.btn.showRefuseButton = show
      this.btn.showAgreeButton = show
      this.btn.showSubmitAuditButton = show
      this.btn.showCloseButton = !show
      this.btn.showConfirmButton = !show
    },
    /**
     * 按钮显示控制
     * @param show
     */
    buttonShow(show) {
      this.btn.showRefuseButton = show
      this.btn.showAgreeButton = show
      this.btn.showSubmitAuditButton = !show
      this.btn.showCloseButton = !show
    },
    /**
     * @private
     */
    checkingResultHandler(results) {
      this.convertData(results)
    },

    convertData(results) {
      const dataSource = []
      this.loadings.length = 0
      this.checkState = 'success'
      this.auditType = false
      if (results && results.length > 0) {
        for (const checkRule of results) {
          if (!checkRule['match'] && checkRule['continueCheck'] && checkRule['checkMode'] === CheckRuleConstants.MODE_WARNING.code && this.checkState === 'success') { this.checkState = 'warning' }
          if (!checkRule['match'] && !checkRule['continueCheck']) { this.checkState = 'failure' }

          // 目前只处理预提交的审核
          if (!checkRule['match'] && checkRule['checkMode'] === CheckRuleConstants.MODE_AUDIT.code &&
            !checkRule['continueCheck'] && (checkRule['checkNode'] === 1 || checkRule['checkNode'] === 2)) { this.auditType = true }

          const node = {}
          node['type'] = 'node'
          node['name'] = checkRule['ruleName']
          node['checkMode'] = checkRule['checkMode']
          node['checkCategory'] = checkRule['checkCategory']
          dataSource.push(node)

          // 子集验证项
          for (const item of checkRule['expressions']) {
            const obj = {}
            obj['type'] = 'item'
            obj['name'] = item['checkItem']
            obj['value'] = item['checkValue']
            obj['operator'] = item['operator']
            obj['match'] = item['match']
            obj['customDescription'] = item['customDescription']
            // // todo-shengsheng  Desc: obj['checking'] = true 原cargo的timeer 重新 设置为false,先测试，
            obj['checking'] = false
            obj['node'] = node
            dataSource.push(obj)
            this.loadings.push(obj)
          }
        }
        this.currentState = this.checkState
        // startTimer();
        // todo-shengsheng  Desc: startTimer(); 定时器 vue不需要，待测
        // console.log('dataSource', dataSource)
        this.dataSource = dataSource
      } else {
        this.currentState = this.checkState
        this.showCheckResultDisplay = true
      }
      if (this.checkState === 'failure' && this.auditType) {
        if (this.checkNode === 10) {
          this.buttonShow(true)
          this.areaRejectRemark.visible = this.areaRemark.visible = true
          this.remarkShow(false)
          this.remarkRejectShow(false)
          this.remarkEdit(false)
        } else {
          this.buttonShow(false)
          this.remarkShow(true)
          this.areaRemark.visible = true
          if (this.job.manageAuditRejectRemark != null && this.job.manageAuditRejectRemark !== '') {
            this.areaRejectRemark.visible = this.areaRejectRemark.includeInLayout = true
            this.remarkRejectShow(true)
          } else {
            this.rejectShow()
          }
          this.remarkEdit(true)
        }
        this.remarkData()
      } else {
        // 审核人显示
        if (this.checkNode === 10) {
          this.buttonShow(true)
          this.areaRejectRemark.visible = this.areaRemark.visible = true
          this.remarkShow(false)
          this.remarkEdit(false)
          this.remarkRejectShow(false)
          this.remarkData()
        } else {
          if (this.checkState === 'success') {
            this.currentState = this.checkState
          }
          this.buttonShow2(false)
          this.labelRejectRemark.visible = this.labelRemark.visible = false
          this.labelRejectRemark2.visible = this.labelRemark2.visible = false
          this.areaRejectRemark.visible = this.areaRemark.visible = false
        }
        this.btn.showSubmitAuditButton = false
      }
      this.confirmButtonShow()

      // Auto-close only when the dialog is actually shown (non-popupMode flows).
      // This avoids double-calling callbacks for popupMode nodes that already auto-close upstream.
      // Treat "warning" as passable too (user can continue), so auto-close on success OR warning.
      if (this.isDebugEnabled()) {
        // eslint-disable-next-line no-console
        console.log(`[CheckingWindow][debug] convertData result: checkNode=${this.checkNode} checkState=${this.checkState} currentState=${this.currentState} innerVisible=${this.innerVisible} autoCloseOnSuccess=${this.autoCloseOnSuccess}`)
      }
      if (this.autoCloseOnSuccess && (this.checkState === this.states.success || this.checkState === this.states.warning) && this.innerVisible) {
        const msgType = this.checkState === this.states.success ? 'success' : 'warning'
        this.$message[msgType](this.$t('Message.N0VerificationPassed', [this.title]))
        if (this.isDebugEnabled()) {
          // eslint-disable-next-line no-console
          console.log('[CheckingWindow][debug] auto-close triggered -> continueHandler()')
        }
        this.continueHandler()
      }
    },

    /**
     * 文本框高度及文字控制
     */
    remarkData() {
      if (this.areaRemark.visible) {
        this.areaRemark.height = 160
        this.areaRemark.text = this.job.manageAuditRemark
      }
      if (this.areaRejectRemark.visible && ((this.job.manageAuditRejectRemark != null && this.job.manageAuditRejectRemark !== '') || (this.checkNode === 10))) {
        this.areaRemark.height = 80
        this.areaRejectRemark.text = this.job.manageAuditRejectRemark
      }
    },

    /**
     * 提交人备注编辑控制
     * @param isEdit
     */
    remarkEdit(isEdit) {
      if (this.areaRemark.visible) {
        this.areaRemark.editable = isEdit
      }
      if (this.areaRejectRemark.visible) {
        this.areaRejectRemark.editable = !isEdit
      }
    },
    /**
     * 显示审核人标签
     * @param isEdit
     */
    remarkRejectShow(isEdit) {
      this.labelRejectRemark.visible = isEdit
      this.labelRejectRemark2.visible = !isEdit
      if (isEdit) {
        this.labelRejectRemark.text = this.$t('Message.RemarksReviewedBy')
      } else {
        this.labelRejectRemark2.text = this.$t('Message.PleaseFillInTheRemarks')
      }
    },

    rejectShow() {
      this.labelRejectRemark2.visible = this.labelRejectRemark.visible = false
      this.areaRejectRemark.visible = false
    },

    confirmButtonShow() {
      if (this.btn.showConfirmButton && (this.areaRemark.visible === false)) {
        this.btn.showConfirmButton = true
      } else {
        this.btn.showConfirmButton = false
      }
    },

    async submitAgreeHandler() {
      if (this.job != null) {
        // await User.getUser(job.submitterUser, new mx.rpc.Responder(loadUser2Handler, faultHandler));
        await getUserByUserId(this.job.submitterUser).then(res => {
          this.loadUser2Handler(new User(res.data))
        }).catch(() => {
          this.faultHandler()
        })
      } else {
        this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
      }
    },
    async loadUser2Handler(user) {
      // 获取此用户上级主管
      if (!user || Number(user.manager) === 0 || Number(user.manager) !== this.currentUserId) {
        this.$message.warning(this.$t('Message.YouAreNotTheSubmitter'))
        return
      } else {
        // await job.auditSubmission(job.key, job.submitterUser, 2,areaRejectRemark.text, agreeHandler, faultHandler);
        await auditSubmission(this.job.uuid, this.job.submitterUser, 2, this.areaRejectRemark.text).then(res => {
          this.agreeHandler()
        }).catch(() => {
          this.faultHandler()
        })
      }
    },

    /**
     * @private
     */
    async submitRefuseHandler() {
      const text = this.areaRejectRemark.text
      if (text === null || text === '') {
        this.$message.warning(this.$t('Message.PleaseFillInTheRemarksSigh'))
        return
      }
      if (this.job != null) {
        // User.getUser(job.submitterUser, new mx.rpc.Responder(loadUser3Handler, faultHandler));
        await getUserByUserId(this.job.submitterUser).then(res => {
          this.loadUser3Handler(new User(res.data))
        }).catch(() => {
          this.faultHandler()
        })
      } else {
        this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
      }
    },

    async loadUser3Handler(user) {
      // 获取此用户上级主管
      if (user === null || user.manager === 0 || user.manager !== this.currentUserId) {
        this.$message.warning(this.$t('Message.YouAreNotTheSubmitter'))
        return
      } else {
        this.job.manageAuditRejectRemark = this.areaRejectRemark.text
        // job.auditSubmission(job.key, job.submitterUser, 3, job.manageAuditRejectRemark,refuseHandler, faultHandler);
        await auditSubmission(this.job.uuid, this.job.submitterUser, 3, this.job.manageAuditRejectRemark).then(res => {
          this.refuseHandler()
        }).catch(() => {
          this.faultHandler()
        })
      }
    },

    /**
     * @private
     */
    async submitAuditHandler() {
      const text = this.areaRemark.text
      if (!text) {
        this.$message.warning(this.$t('Message.PleaseEnterRemarks'))
        return
      }
      if (this.job) {
        // 获取操作用户信息
        // User.getUser(Session.getInstance().user.userId, new mx.rpc.Responder(loadUserHandler, faultHandler));
        await getUserByUserId(this.currentUserId).then(res => {
          this.loadUserHandler(new User(res.data))
        }).catch(() => {
          this.faultHandler()
        })
      } else {
        this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
      }
    },

    async loadUserHandler(user) {
      // 获取此用户上级主管
      if (!user || (user && Number(user.manager) === 0)) {
        this.$message.warning(this.$t('Message.TheTheCurrentOperationMaintenance'))
        return
      } else {
        // 保存备注信息 发送消息通知
        // job.saveOrderAuditRemark(job.key, areaRemark.text, this.checkNode, user.manager, successHandler, faultHandler);
        await saveOrderAuditRemark(this.job.uuid, this.areaRemark.text, this.checkNode, user.manager, this.currentUserId, this.currentUserName).then(res => {
          this.successHandler(res.data)
        }).catch(() => {
          this.faultHandler()
        })
      }
    },

    /**
     * @private
     * 审核提交成功
     */
    successHandler(resultFlag) {
      if (resultFlag === 0) {
        this.$message.warning(this.$t('Message.FailedForApprovalPleaseAgain'))
      } else {
        this.$message.success(this.$t('Message.SubmittedSupervisorForApprovalSuccessfully'))
        if (this.callBack != null) {
          this.callBack()
        }
        this.toCloseDialog()
      }
    },
    closeHandler() {
      if (this.closeCallback) {
        this.closeCallback()
      }
      this.toCloseDialog()
    },
    /**
     * @private
     * 审核已同意
     */
    agreeHandler() {
      if (this.callBack) { this.callBack() }
      this.$message.success(this.$t('Message.ApprovedPass'))
      this.toCloseDialog()
    },

    /**
     * @private
     * 审核已拒绝
     */
    refuseHandler() {
      this.$message.success(this.$t('Message.ApprovalRejected'))
      if (this.callBack2) {
        this.callBack2()
      }
      this.toCloseDialog()
    },
    /**
     * @private
     */
    continueHandler() {
      if (this.callBack != null) {
        this.returnValue = this.callBack()
        if (this.returnValue) {
          this.$emit('returnCallBack', this.returnValue)
        }
      }
      this.toCloseDialog()
    },
    faultHandler() {
      this.$message.warning(this.$t('Message.ThePleaseRefreshAndAgain'))
    },
    toCloseDialog() {
      // 验证规则验证业务之后需要更新业务
      this.$emit('closeCallback')
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body{
  .single-wrap{
    border: 1px solid #EAEEF5;
    height: 310px;
    > .el-scrollbar{
      height: 310px;
      .el-scrollbar__wrap{
        overflow-x: hidden;
        .el-scrollbar__view{
          padding-bottom: 20px;
        }
      }
      .is-vertical{
        opacity: 1;
        .el-scrollbar__thumb{
          background-color: rgba(153, 153, 153, 0.8);
        }
      }
    }
  }
  .app-main-inner-row{
    line-height: 30px;
  }
  textarea{
    height: 80px;
  }
}
</style>
<style>
  .checking-window .el-dialog__body{
    padding: 0px 10px!important;
  }
</style>
